// zustandのcreateをラップして、全てのstoreの状態をリセットできるようにする
// ref: https://github.com/pmndrs/zustand/blob/56a39b6a0f8f475563387f6ed623891bb0e01ad8/docs/guides/how-to-reset-state.md
import type { StateCreator } from "zustand";
import { create as actualCreate } from "zustand";

const storeResetFns = new Set<() => void>();

export const resetAllStores = () => {
  for (const resetFn of storeResetFns) {
    resetFn();
  }
};

export const create = (<T>() => {
  return (stateCreator: StateCreator<T>) => {
    const store = actualCreate(stateCreator);
    storeResetFns.add(() => {
      store.setState(store.getInitialState(), true);
    });
    return store;
  };
}) as typeof actualCreate;
